import {
  PreferenceCardsApiClient,
  createPreferenceCardsApiClient,
} from '@peritasai/data-access';
import type {
  CreatePreferenceCardDto,
  PaginatedPreferenceCardsResponseDto,
  PreferenceCardsFilterParams,
  UpdatePreferenceCardDto,
} from '@peritasai/types';
import { PreferenceCardListItemEntity } from './preference-card-list.entity';

export interface IPreferenceCardsRepository {
  getPreferenceCardsPaginated(
    options: PreferenceCardsFilterParams
  ): Promise<PaginatedPreferenceCardsResponseDto & { preferenceCards: PreferenceCardListItemEntity[] }>;
  createPreferenceCard(dto: CreatePreferenceCardDto): Promise<PreferenceCardListItemEntity | null>;
  createPreferenceCardVersion(
    id: string,
    dto: UpdatePreferenceCardDto
  ): Promise<PreferenceCardListItemEntity | null>;
}

export class PreferenceCardsRepository implements IPreferenceCardsRepository {
  constructor(private readonly apiClient: PreferenceCardsApiClient) {}

  async getPreferenceCardsPaginated(
    options: PreferenceCardsFilterParams = {}
  ): Promise<PaginatedPreferenceCardsResponseDto & { preferenceCards: PreferenceCardListItemEntity[] }> {
    const response = await this.apiClient.getPreferenceCards(options);
    return {
      ...response,
      preferenceCards: response.data.map((dto) => new PreferenceCardListItemEntity(dto)),
    };
  }

  async createPreferenceCard(dto: CreatePreferenceCardDto): Promise<PreferenceCardListItemEntity | null> {
    await this.apiClient.createPreferenceCard(dto);
    return null;
  }

  async createPreferenceCardVersion(
    id: string,
    dto: UpdatePreferenceCardDto
  ): Promise<PreferenceCardListItemEntity | null> {
    await this.apiClient.createPreferenceCardVersion(id, dto);
    return null;
  }
}

export const preferenceCardsRepository = new PreferenceCardsRepository(
  createPreferenceCardsApiClient()
);
